import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { SelectedSubstationForSchematic } from '../nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component';
import { BaseVoltage } from '../../../models/base-voltage.model';
import { BaseVoltageService } from '../../../services/base-voltage.service';
import { ToastrService } from 'ngx-toastr';
import { Voltage } from '../../../enums/voltage';
import { PowerTransformerCrud, PowerTransformerFilter, PowerTransformerSearchType } from '../../../models/power-transformer.model';
import { PowerTransformerService } from '../../../services/power-transformer.service';
import { GeographicalRegion } from '../../../models/geographical-region.model';
import { SubGeographicalRegion } from '../../../models/sub-geographical-regions.model';
import { SubstationTemplateForSelectDataOut } from '../../../models/substation-template.model';
import { AssetRating } from '../../../models/asset-rating.model';
import { GeographicalRegionService } from '../../../services/geographical-region.service';
import { SubGeographicalRegionService } from '../../../services/sub-geographical-region.service';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { AssetRatingService } from '../../../services/asset-rating.service';
import { NecUploadModalPowerTransformerComponent } from '../nec-modals/upload-modals/nec-upload-modal-power-transformer/nec-upload-modal-power-transformer.component';
import { UploadFileType } from '../../../models/uploadFileInfo.model';
import { PermissionsService } from '../../../services/permissions.service';


@Component({
  selector: 'lib-nec-power-transformer',
  templateUrl: './nec-power-transformer.component.html',
  styleUrls: ['./nec-power-transformer.component.scss', '../network-entity-classes.component.scss'],
  standalone: false
})
export class NecPowerTransformerComponent implements OnInit {
  searchDropdownOpened: boolean = false;
  filterOpened: boolean = false;
  modalOpened: boolean = false;
  isAddNewInstanceEquipmentOpen: boolean = false;
  @Output() openSubstationSchematic = new EventEmitter<SelectedSubstationForSchematic>();
  PowerTransformerSearchType = PowerTransformerSearchType;

  UploadFileType: UploadFileType = UploadFileType.CimPowerTransformer;
  uploadModalOpened: boolean = false; 
  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];
  count: number = 0;
  filter = new PowerTransformerFilter();

  transformers: PowerTransformerCrud[] = [];
  actionMenuOpenForId: number | null = null;
  selectedPtId: { value: number | null } | null = null;

  geoRegions: GeographicalRegion[] = [];
  allSubGeoRegions: SubGeographicalRegion[] = [];
  substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];
  ratingOptions: AssetRating[] = [];
  
  @ViewChild(NecUploadModalPowerTransformerComponent) necUploadModalPowerTransformerComponent!: NecUploadModalPowerTransformerComponent;
  
  constructor(
    private powerTransformerService: PowerTransformerService,
    private toastr: ToastrService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private substationTemplateService: SubstationTemplateService,
    private assetRatingService: AssetRatingService,
    public permissionsService: PermissionsService
  ){}

  ngOnInit(): void {
    this.filter.searchType = PowerTransformerSearchType.Name;
    this.getAllPowerTransformer();
    this.loadGeographicalRegions();
    this.loadAllSubGeographicalRegions();
    this.loadSubstationTemplates();
    this.loadRatings();
  }

  openUploadModal() {
    this.uploadModalOpened = true;
  }

  openAddModal(){
    this.isAddNewInstanceEquipmentOpen = true;
  }

  onAddNewInstanceEquipmentClosed(){
    this.isAddNewInstanceEquipmentOpen = false;
  }

  onAddNewInstanceEquipmentProceed(selected: SelectedSubstationForSchematic){
    this.isAddNewInstanceEquipmentOpen = false;
    this.openSubstationSchematic.emit(selected);
  }


  onPageChange(page: number) {
    this.currentPage = page;
    this.reloadTable();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.reloadTable()
  }

  reloadTable(){
    this.getAllPowerTransformer();
  }

   toggleMenu(pt: any, event: MouseEvent) {
    event.stopPropagation();
    this.actionMenuOpenForId = this.actionMenuOpenForId === pt.id ? null : pt.id;
  }

  selectSearchType(searchType: PowerTransformerSearchType){
    this.filter.searchType = searchType;
    this.searchDropdownOpened = false;
  }

  onFilterApplied() {
    this.currentPage = 1;
    this.getAllPowerTransformer();
    this.filterOpened = false;
  }

  getSearchTypeLabel(): string {
    switch(this.filter.searchType) {
      case PowerTransformerSearchType.Name:
        return 'Asset Name';
      case PowerTransformerSearchType.SubstationName:
        return 'Substation Name';
      default:
        return 'Asset Name';
    }
  }

  getAllPowerTransformer(){
    var dataIn = {
      pageInfo: {
        pageSize: this.pageSize,
        page: this.currentPage
      },
      filterParams: this.filter
    }
    this.powerTransformerService.getAll(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if(responseData.status == 'OK'){
          this.count = responseData.data.count ?? this.count;
          this.transformers = responseData.data.data.map((transformer: any) => ({
            ...transformer,
            primaryWinding: `${transformer.primaryWinding}KV`,
            secondaryWinding: `${transformer.secondaryWinding}KV`
          }));
        }
        else {
          this.toastr.error(responseData?.message || 'Failed to fetch Power Transformer list data');
        }
      }
    });
  }

  download() {
    const dataIn = {
      pageInfo: {
        pageSize: this.pageSize,
        page: this.currentPage
      },
      filterParams: this.filter
    };

    this.powerTransformerService.downloadFile(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response?.body;
        if (responseData?.status === 'OK' || responseData?.status === 200) {
          window.location.href = responseData.data;
        } else {
          this.toastr.error(responseData?.message || 'Failed to download Power Transformer file');
        }
      },
      error: (_) => {
        this.toastr.error('Failed to download Power Transformer file');
      }
    });
  }

  selectPt(ptId: number){
    this.actionMenuOpenForId = null;
    this.selectedPtId = { value: ptId} ;
    this.modalOpened = true;
  }

  loadGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            name: geoRegion.name.toUpperCase()
          }));
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch geographical regions');
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch geographical regions');
      },
    });
  }

  loadAllSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.allSubGeoRegions = responseData.data.map((subGeoRegion: SubGeographicalRegion) => ({
            ...subGeoRegion,
            name: subGeoRegion.name.toUpperCase()
          }));
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch sub-geographical regions');
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch sub-geographical regions');
      },
    });
  }

  loadSubstationTemplates() {
    this.substationTemplateService.getAllForSelect().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData && responseData.status === 'OK') {
          this.substationTemplateOptions = responseData.data;
        } else {
          this.substationTemplateOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch substation templates');
      },
    });
  }

  loadRatings() {
    this.assetRatingService.getAllForSelect().subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.ratingOptions = response.data;
        } else {
          this.ratingOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch ratings');
      },
    });
  }
}
